export interface SearchableDropdownItem {
    id: string
    displayName: string
}

export const KEYS = {
    ENTER: "Enter",
    ARROW_DOWN: "ArrowDown",
    ARROW_UP: "ArrowUp",
    ESCAPE: "Escape",
    TAB: "Tab",
    CLOSE_TAG: ">"
}